import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { SessionStorageManager } from '@atlas/core';

import { REDIRECT_DATA_AFTER_DEPOSIT } from 'src/common/constants';

const useSetRedirectUrl = () => {
  const { pathname, search } = useLocation();

  return useCallback(
    paymentMethod => {
      SessionStorageManager.setItem(
        REDIRECT_DATA_AFTER_DEPOSIT,
        JSON.stringify({
          alternativePmEnabled: !!paymentMethod?.alternativePmEnabled,
          expirationTime: Date.now() + 2 * 3600 * 1000,
          pmId: paymentMethod?.id,
          url: `${pathname}${search}`,
        }),
      );
    },
    [pathname, search],
  );
};

export default useSetRedirectUrl;
